import { ACTION } from './types';
import SharedPropsService from '../../../SharedPropsService';
import _ from 'lodash';
import { ROUTE } from '../../../routes';
import { api } from '../../../configs/api';
import { APP_CONFIG, AssetRepositoryMap, AssetRepositoryType, getAppHeader, } from '../../../configs/config';
import { IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, StepperStateToken, WIDGET, } from '@voltmoney/schema';
import { addCommasToNumber, nextStepId, roundDownToNearestHundred, } from '../../../configs/utils';
import { AnalyticsEventTracker, TextConstants, } from '../../../configs/constants';
import AsyncStorage from "@react-native-async-storage/async-storage";
let resendCount = 1;
export const verifyOTP = async (action, _datastore, { setDatastore, showPopup, network, goBack, analytics, appendWidgets, removeWidgets, ...props }) => {
    /** get current asset repository globally**/
    const assetRepositoryType = AssetRepositoryType[await SharedPropsService.getAssetRepositoryType()];
    const sendOtpForPledgeConfirmAction = action.payload.sendOtpForPledgeConfirmAction;
    /** reject if otp length is not matching as config */
    if (action.payload.value.length !==
        AssetRepositoryMap.get(assetRepositoryType).OTP_LENGTH) {
        return;
    }
    /** verification done, init api call loader */
    await setDatastore(ROUTE.PLEDGE_VERIFY, "otpModalScreen", {
        state: InputStateToken.LOADING,
    });
    /** get current application id of user **/
    const user = await SharedPropsService.getUser();
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    /** Actual Api call for pledge verify **/
    const authPledgeResponse = await network.post(api.authPledge, {
        applicationId: applicationId,
        assetRepository: assetRepositoryType,
        otp: action.payload.value,
    }, { headers: await getAppHeader() });
    if (_.get(authPledgeResponse, 'data.status') === 'SUCCESS') {
        analytics(AnalyticsEventTracker.borrower_mf_pledge_complete['Event Name'], {
            ...AnalyticsEventTracker.borrower_mf_pledge_complete,
        });
        await setDatastore(ROUTE.PLEDGE_VERIFY, "otpModalScreen", {
            state: InputStateToken.SUCCESS,
        });
        //await goBack()
        AssetRepositoryMap.get(assetRepositoryType).IS_PLEDGED = true;
        /*** update user application obj ***/
        user.linkedApplications[0] = _.get(authPledgeResponse, 'data.updatedApplicationObj', user.linkedApplications[0]);
        /*** update user obj ***/
        await SharedPropsService.setUser(user);
        /*** update UI manually for next asset repository since we are not re-building the page ***/
        if (assetRepositoryType === AssetRepositoryType.KARVY) {
            // await setDatastore(ROUTE.PLEDGE_VERIFY, 'input', <TextInputProps>{
            //     state: InputStateToken.DEFAULT,
            //     charLimit: AssetRepositoryMap.get(AssetRepositoryType.CAMS)
            //         .OTP_LENGTH,
            // })
            await setDatastore(ROUTE.PLEDGE_VERIFY, 'subTitle', {
                label: `${AssetRepositoryType.CAMS} has sent ${AssetRepositoryMap.get(AssetRepositoryType.CAMS).OTP_LENGTH}-digit OTP was sent on `,
            });
        }
        else if (assetRepositoryType === AssetRepositoryType.CAMS) {
            await setDatastore(ROUTE.PLEDGE_VERIFY, 'subTitle', {
                label: `${AssetRepositoryType.KARVY} has sent ${AssetRepositoryMap.get(AssetRepositoryType.KARVY).OTP_LENGTH}-digit OTP was sent on `,
            });
            await removeWidgets(ROUTE.PLEDGE_VERIFY, [{
                    id: "input", type: WIDGET.INPUT
                }]);
            await appendWidgets(ROUTE.PLEDGE_VERIFY, {
                kamsInput: {
                    resendTimer: AssetRepositoryMap.get(assetRepositoryType).OTP_LENGTH == 5 ? 60 : 15,
                    type: InputTypeToken.OTP,
                    state: InputStateToken.DEFAULT,
                    charLimit: AssetRepositoryMap.get(AssetRepositoryType.KARVY)
                        .OTP_LENGTH,
                    keyboardType: KeyboardTypeToken.numberPad,
                    action: {
                        type: ACTION.PLEDGE_VERIFY,
                        payload: {
                            value: "",
                            widgetId: "kamsInput",
                            assetRepositoryType,
                            sendOtpForPledgeConfirmAction,
                        },
                        routeId: ROUTE.PLEDGE_VERIFY,
                    },
                    otpAction: {
                        type: ACTION.RESEND_OTP_NUMBER,
                        payload: { assetRepository: assetRepositoryType },
                        routeId: ROUTE.PLEDGE_VERIFY,
                    },
                },
            }, [
                { id: "kamsInput", type: WIDGET.INPUT }
            ], "input");
        }
        /*** check whether all asset repository is pledged or not ***/
        if ((AssetRepositoryMap.get(AssetRepositoryType.KARVY).IS_PLEDGED ||
            AssetRepositoryMap.get(AssetRepositoryType.KARVY).LIST
                .length === 0) &&
            (AssetRepositoryMap.get(AssetRepositoryType.CAMS).IS_PLEDGED ||
                AssetRepositoryMap.get(AssetRepositoryType.CAMS).LIST.length ===
                    0)) {
            console.warn("Reached wrong block");
            /*** if all pledged then continue normal flow ***/
            const mfPledgePortfolioStatus = _.get(authPledgeResponse, 'data.updatedApplicationObj.stepStatusMap.MF_PLEDGE_PORTFOLIO');
            if (mfPledgePortfolioStatus === 'COMPLETED') {
                /*** close previous popup ***/
                await goBack();
                /*** show success popup ***/
                await showPopup({
                    id: 'bt_commonConfirmPledge_continue',
                    autoTriggerTimerInMilliseconds: APP_CONFIG.POLLING_INTERVAL,
                    isAutoTriggerCta: false,
                    titleFont: false,
                    title: `₹ ${addCommasToNumber(roundDownToNearestHundred(_.get(authPledgeResponse, 'data.stepResponseObject.approvedCreditAmount', 0)))} unlocked successfully!`,
                    subTitle: TextConstants.GENERIC_PROCEED_MESSAGE,
                    type: 'SUCCESS',
                    ctaLabel: 'Continue',
                    primary: true,
                    ctaAction: {
                        type: ACTION.NAV_NEXT,
                        routeId: ROUTE.PLEDGE_VERIFY,
                        payload: {
                            stepId: _.get(authPledgeResponse, 'data.updatedApplicationObj.currentStepId'),
                        },
                    },
                });
            }
            else if (mfPledgePortfolioStatus === StepperStateToken.PENDING_CALLBACK) {
                /*** close previous popup ***/
                await goBack();
                /*** show popup for pending callback ***/
                await showPopup({
                    title: `Pledging...`,
                    subTitle: 'Please wait while we confirm your pledge with depository.',
                    type: 'DEFAULT',
                    iconName: IconTokens.Volt,
                });
                /***** Starting Polling to check status of MF_PLEDGE_PORTFOLIO *****/
                const PollerRef = setInterval(async () => {
                    const mfPledgeStatusResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
                    user.linkedApplications[0] = _.get(mfPledgeStatusResponse, 'data');
                    await SharedPropsService.setUser(user);
                    if (_.get(mfPledgeStatusResponse, 'data.stepStatusMap.MF_PLEDGE_PORTFOLIO') === 'COMPLETED' &&
                        _.get(mfPledgeStatusResponse, 'data.currentStepId') !==
                            'MF_PLEDGE_PORTFOLIO') {
                        clearInterval(PollerRef);
                        await goBack();
                        await showPopup({
                            autoTriggerTimerInMilliseconds: APP_CONFIG.POLLING_INTERVAL,
                            isAutoTriggerCta: false,
                            title: `₹ ${addCommasToNumber(roundDownToNearestHundred(_.get(authPledgeResponse, 'data.stepResponseObject.approvedCreditAmount', 0)))} unlocked successfully!`,
                            subTitle: TextConstants.GENERIC_PROCEED_MESSAGE,
                            type: 'SUCCESS',
                            ctaLabel: 'Continue',
                            primary: true,
                            ctaAction: {
                                type: ACTION.NAV_NEXT,
                                routeId: ROUTE.PLEDGE_VERIFY,
                                payload: {
                                    stepId: _.get(mfPledgeStatusResponse, 'data.currentStepId'),
                                },
                            },
                        });
                    }
                }, APP_CONFIG.POLLING_INTERVAL);
            }
        }
        else {
            console.warn("Reached this block");
            await showPopup({
                id: 'bt_commonConfirmPledge_continue',
                autoTriggerTimerInMilliseconds: APP_CONFIG.POLLING_INTERVAL,
                isAutoTriggerCta: false,
                titleFont: false,
                title: `₹ ${addCommasToNumber(roundDownToNearestHundred(_.get(authPledgeResponse, 'data.stepResponseObject.approvedCreditAmount', 0)))} unlocked successfully!`,
                subTitle: 'Please continue to unlock the remaining amount',
                type: 'SUCCESS',
                ctaLabel: 'Continue',
                primary: true,
                ctaAction: action.payload.sendOtpForPledgeConfirmAction,
            });
        }
        removeWidgets(ROUTE.PLEDGE_VERIFY, [
            {
                id: "otpModalScreen",
                type: WIDGET.OTP_MODAL_SCREEN,
            }
        ]);
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
export const NavigateNext = async (action, _datastore, { navigate, goBack, navigateToBase }) => {
    AssetRepositoryMap.get(AssetRepositoryType.CAMS).IS_PLEDGED = false;
    AssetRepositoryMap.get(AssetRepositoryType.KARVY).IS_PLEDGED = false;
    await goBack();
    const user = await SharedPropsService.getUser();
    const currentStepId = user.linkedApplications[0].currentStepId;
    const routeObj = await nextStepId(currentStepId);
    await navigateToBase(routeObj.routeId, routeObj.params);
};
export const resendOTP = async (action, _datastore, { instrumentTrack, setDatastore, network }) => {
    const assetRepositoryType = action.payload.assetRepository;
    instrumentTrack("MF_PLEDGE_OTP_RESEND", { "type": assetRepositoryType, "attempt_count": resendCount });
    resendCount++;
    const resendOtpResponse = await network.post(api.pledgeCreate, {
        applicationId: (await SharedPropsService.getUser()).linkedApplications[0].applicationId,
        assetRepository: assetRepositoryType,
        portfolioItemList: AssetRepositoryMap.get(AssetRepositoryType[assetRepositoryType]).LIST,
    }, { headers: await getAppHeader() });
    if (_.get(resendOtpResponse, 'data.status') === 'SUCCESS') {
        await setDatastore(ROUTE.PLEDGE_VERIFY, "otpModalScreen", {
            state: InputStateToken.DEFAULT,
        });
    }
};
